<template>
  <div id="sf-express-ensure-modal">
    <el-dialog title="提示" v-model="showModal" custom-class="pay-dialog" :show-close="false" :close-on-click-modal="false">
      <span>请确认邮寄资料已备齐，以免快递无法取件。若尚未备齐，可在订单支付后重新选择顺丰上门取资料服务</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="materialNotReady">尚未备齐</el-button>
        <el-button type="primary" @click="isAllMaterialReady">资料已备齐</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'sf-express-ensure-modal',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.value,
    };
  },
  methods: {

    // 没准备好
    materialNotReady() {
      MtaH5.clickStat('payvisaorder0shunfengnotready');
      this.$emit('input', false);
      this.$emit('sfCheckChange', false);
    },

    // 准备好了
    isAllMaterialReady() {
      MtaH5.clickStat('payvisaorder0shunfengready');
      this.$emit('sfCheckChange', true);
      this.$emit('input', false);
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
  },
};
</script>
<style lang="less">
#sf-express-ensure-modal {
  .pay-dialog {
    width: 480px;
    text-align: center;
    border-radius: 5px;

    .el-dialog__header {
      padding-top: 48px;
    }

    .el-dialog__title {
      font-size: 22px;
      color: #333;
      font-weight: 300;
    }

    .el-dialog__body {
      font-size: 18px;
      padding: 38px 20px;
      line-height: 1.5;
    }

    .el-dialog__footer {
      text-align: center;
      padding-bottom: 38px;

      .el-button {
        width: 150px;
        font-size: 16px;

        & + .el-button {
          margin-left: 22px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/modals/sf-express-ensure-modal.vue